// extracted by mini-css-extract-plugin
export default {"logo_white":"Logo_logo_white__v2biU","logo_black":"Logo_logo_black__KHMb+","footer":"Logo_footer__XvZC7"};